import { ICreateWidgetModalService } from "./i-create-widget-modal.service";
import { Inject, Injectable } from "@angular/core";
import { IModalService, modalServiceInjectionToken } from "@zaeper/angular-dashboard-view-lib";
import { CreateWidgetModalComponent } from "./create-widget-modal.component";
import { ICreateWidgetModalOptions } from "./i-create-widget-modal.options";

@Injectable()
export class CreateWidgetModalService implements ICreateWidgetModalService {
  constructor(@Inject( modalServiceInjectionToken ) private readonly _modalService: IModalService) {
  }

  public open(options: ICreateWidgetModalOptions): void {
    this._modalService.open( CreateWidgetModalComponent, {
      styleClass: 'bg-white rounded-lg',
      header: "Widget erstellen",
      showHeader: true,
      closable: true,
      width: '900px',
      closeOnEscape: true,
      dismissableMask: true,
      data: options
    } )
  }
}
